var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-popup"},[(_vm.mapState === 'success')?_c('daum-map',{attrs:{"mapData":_vm.mapData,"setArea":true,"setInfoWindow":true}}):_c('div',{staticClass:"loader-wrap"},[(_vm.mapState === 'load')?_c('loader'):(_vm.mapState === 'fail')?_c('div',{staticClass:"state-message"},[_vm._v("정보를 불러오지 못했습니다.")]):(_vm.mapState === 'empty')?_c('div',{staticClass:"state-message"},[_vm._v("조회된 정보가 없습니다.")]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f5a2f64","hasScoped":true,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/MapPopup.vue
// module id = 1015
// module chunks = 1